export const ACCESS_TOKEN_TTL_MS = 6 * 3600 * 1000;
export const REFRESHED_TOKEN_TTL_MS = 12 * 3600 * 1000;

const canUseLocalStorage = () =>
  typeof window !== "undefined" && window.localStorage;

const getLocalStorageItem = (key) => {
  if (!canUseLocalStorage()) return null;
  return localStorage.getItem(key);
};

const setLocalStorageItem = (key, value) => {
  if (!canUseLocalStorage() || value === undefined || value === null) return;
  localStorage.setItem(key, value);
};

const removeLocalStorageItem = (key) => {
  if (!canUseLocalStorage()) return;
  localStorage.removeItem(key);
};

const getStoredUser = () => {
  try {
    const user = getLocalStorageItem("userData");
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

const resolveExpiresAt = (data, fallbackTtlMs) => {
  if (data.expiresAt) return data.expiresAt;
  if (data.expires_at) return data.expires_at;
  if (data.expires_in) return Date.now() + Number(data.expires_in) * 1000;
  return Date.now() + fallbackTtlMs;
};

export const normalizeAuthSession = (
  data = {},
  previousAuth = {},
  fallbackTtlMs = ACCESS_TOKEN_TTL_MS
) => {
  const user = data.user ?? data.userData ?? previousAuth.userData ?? getStoredUser();
  const responseAccessToken =
    data.access_token ??
    data.accessToken ??
    data.account_token ??
    data.accountToken;
  const accessToken =
    responseAccessToken ??
    previousAuth.accessToken ??
    getLocalStorageItem("accessToken");
  const refreshToken =
    data.refresh_token ??
    data.refreshToken ??
    responseAccessToken ??
    previousAuth.refreshToken ??
    getLocalStorageItem("refreshToken") ??
    accessToken;

  return {
    user,
    access_token: accessToken,
    refresh_token: refreshToken,
    expiresAt: resolveExpiresAt(data, fallbackTtlMs),
  };
};

export const persistAuthSession = (session) => {
  if (!session) return;

  if (session.user) {
    setLocalStorageItem("userData", JSON.stringify(session.user));
    setLocalStorageItem("user_id", session.user.id);
  }

  setLocalStorageItem("accessToken", session.access_token);
  setLocalStorageItem("refreshToken", session.refresh_token);
  setLocalStorageItem("expiresAt", String(session.expiresAt));
};

export const clearAuthSession = () => {
  removeLocalStorageItem("userData");
  removeLocalStorageItem("accessToken");
  removeLocalStorageItem("refreshToken");
  removeLocalStorageItem("expiresAt");
  removeLocalStorageItem("user_id");
};
